/** Miss row for Adjectives & adverbs — no article, so no gender tint. */
import { MissRowFrame, UserAnswer } from '@/components/practice/SharedMissRow';
import type { AdjectivePayload } from '@/core/types';

import type { MissRowProps } from '../types';

export function MissRow({ card, user_answer }: MissRowProps<AdjectivePayload>) {
  return (
    <MissRowFrame>
      <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-0.5">
        <span className="font-display text-base font-semibold">{card.de}</span>
        <span className="text-base">{(card.translations.en ?? []).join(', ')}</span>
      </div>
      <UserAnswer user_answer={user_answer} verb="wrote" />
    </MissRowFrame>
  );
}
